module.exports = __webpack_public_path__ + "img/news-nav-icon-2.29e9488a.png";